import securityScoreSuccessIcon from "../../../assets/onprem_security_score.svg";
import securityScoreWarningIcon from "../../../assets/SecurityScoreWarning.svg";
import securityScoreErrorIcon from "../../../assets/SecurityScoreError.svg";
import { Stack, Tooltip } from "@mui/material";

const SecurityScoreCellRenderer = (params: { data: { security_score: number } }) => {
  return (
    <Stack direction="row" alignItems="center" className="ag-center">
    <Tooltip
  title={`Security Score: ${params.data.security_score}`}
  arrow
  slotProps={{
    tooltip: {
      sx: {
        backgroundColor: "#fff", 
        color: "#000",           
        boxShadow: 1,
        fontSize: "0.775rem",
      },
    },
    arrow: {
      sx: {
        color: "#fff", 
      },
    },
  }}
>
  <span style={{ display: "flex", alignItems: "center" }}>
    <img
      src={
        params.data.security_score >= 80
          ? securityScoreSuccessIcon
          : params.data.security_score >= 60
          ? securityScoreWarningIcon
          : securityScoreErrorIcon
      }
      alt="security score"
      style={{ width: 20, marginRight: 5 }}
    />
    <span>{Math.round(params.data.security_score)}</span>
  </span>
</Tooltip>

    </Stack>
  );
};

export default SecurityScoreCellRenderer;
